module.exports = __webpack_public_path__ + "static/media/doctor.ffd7f5e9.png";